// extracted by mini-css-extract-plugin
module.exports = {"UserInfo":"UserInfo_UserInfo__oPGJP","container":"UserInfo_container__29afC","avatar":"UserInfo_avatar__13aA4","text":"UserInfo_text__1viOr"};